import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createVuetify } from 'vuetify'
import { registerSW } from 'virtual:pwa-register'
import 'vuetify/styles'
import '@/theme/tokens.css'
import '@/theme/major-cta.css'
import '@/theme/dialogs.css'
import { stringSearchDefaults } from '@/search/vuetifySearch'
import '@/theme/registration-welcome.css'
import '@/features/tryout-home/panel-headers.css'

import '@mdi/font/css/materialdesignicons.css'
import App from '@/app/App.vue'
import router from '@/router'
import { i18n } from '@/i18n'

const app = createApp(App)
const pinia = createPinia()
// Vite development keeps the existing global registrations. Compiled builds
// import the components used by each SFC instead of shipping the entire library.
const componentRegistration=import.meta.env.DEV?{components:await import('vuetify/components'),directives:await import('vuetify/directives')}:{}

const vuetify = createVuetify({
  ...componentRegistration,
  defaults: stringSearchDefaults,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#702AB8',
          secondary: '#2196F3',
          error: '#ef5350',
          warning: '#ffa726',
          info: '#29b6f6',
          success: '#66bb6a',
        },
      },
    },
  },
})

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes default
        gcTime: 10 * 60 * 1000, // 10 minutes cache time
        retry: 1,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchOnMount: true,
      },
    },
  },
})
app.use(vuetify)

if(import.meta.env.VITE_COMPILED_PREVIEW !== 'true')registerSW({
  immediate: true,
  onRegistered(registration) {
    if (!registration) return
    setInterval(() => {
      registration.update().catch((error) => {
        console.error('Service Worker update check failed:', error)
      })
    }, 60 * 1000)
  },
  onRegisterError(error) {
    console.error('Service Worker registration failed:', error)
  },
})

// Handle online/offline events
window.addEventListener('online', () => {
  console.log('Application is now online')
})

window.addEventListener('offline', () => {
  console.log('Application is now offline')
})

app.mount('#app')
